import Route from "../../../router/Route";
import { RouterView } from "vue-router";

export default new Route(
	"capacity",
	"/capacity",
	RouterView,
	[
		new Route(
			"capacity.index",
			"",
			() => import("@/modules/capacity_editor/pages/Index.vue"),
			[],
			{}
		),
		new Route(
			"capacity.asset",
			"asset/:id/:capacity_type(capacity|disruption)", // Will have to be changed if more capacity typed are ever added
			() => import("@/modules/capacity_editor/pages/Asset.vue"),
			[],
			{}
		),
	],
	{ permissions: ["can_manage_capacity"] }
);
